export enum AddBankCardStatus {
  Wait3DSecure = 'wait_3d_secure',
  WaitOpenPage = 'wait_open_page',
  Confirmation = 'confirmation',
  Confirmed = 'confirmed',
  Declined = 'declined'
}
